<template>
  <div class="error-container">
    <div class="error-box">
      <h3 class="error-title">카카오 로그인에 실패했습니다.</h3>
      <p class="error-message">{{ errorMessage }}</p>
      <button class="main-button" @click="goToMain">확인</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['errorCode'],
  computed: {
    errorMessage() {
      if (this.$route.query.em) return decodeURIComponent(this.$route.query.em);
      const messages = {
        'access_denied_cancel': '인증을 취소했습니다.',
        'access_denied_age': '네트워크 오류가 발생했습니다.',
        'network_error': '네트워크 오류가 발생했습니다.',
        'invalid_request': '서버 오류가 발생했습니다.',
        'invalid_kakao': '잘못된 요청입니다. 다시 본인인증을 해주세요',
      };
      return messages[this.errorCode] || '알 수 없는 오류가 발생했습니다.';
    },
  },
  methods: {
    goToMain() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
/* 전체 컨테이너: 화면 중앙 정렬 */
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* 에러 박스: 카드 스타일 */
.error-box {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
  animation: fadeIn 0.5s ease-in-out;
}

/* 제목 스타일 */
.error-title {
  font-size: 1rem;
  color: #ff6b6b;
  margin-bottom: 20px;
  font-weight: bold;
}

/* 메시지 스타일 */
.error-message {
  font-size: 18px;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.5;
}

/* 버튼 스타일 */
.main-button {
  background-color: #4facfe;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.main-button:hover {
  background-color: #00f2fe;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 242, 254, 0.4);
}

/* 애니메이션 정의 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 반응형 디자인 */
@media (max-width: 480px) {
  .error-box {
    padding: 20px;
    max-width: 90%;
  }

  .error-title {
    font-size: 1rem;
  }

  .error-message {
    font-size: 1rem;
  }

  .main-button {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>